export default __webpack_public_path__ + "static/media/woocommerce_logo.3c66bea4.png";